// import i18n from '@/i18n/index'

export default {
  basicInformation: [{
    prop: 'name'
  }, {
    prop: 'hotel'
  }, {
    prop: 'bed_type'
  }, {
    prop: 'capacity'
  }, {
    prop: 'room_size'
  }, {
    prop: 'short_description'
  }, {
    prop: 'feature_details'
  }, {
    prop: 'updated_at'
  }, {
    prop: 'created_at'
  }]
}
